export default "__VITE_ASSET__BWoGwMSO__"